import { ActionType } from './action.model';

export interface WorkflowState {
  startState: string;
  event: string;
  endStateType: 'endStateOne' | 'endStateTwo';
  endStateCode: string;
  actionType: ActionType;
  displayName?: { [key: string]: string };
}

export interface WorkflowConfig {
  workflow: any[];
  nextSteps: any[];
  expectedProcessingTime: number;
  expectedProcessingMeasurementUnit: string;
}

export enum EndState {
  END_STATE_ONE = 'endStateOne',
  END_STATE_TWO = 'endStateTwo',
}
